module.exports = __webpack_public_path__ + "3b5e348ac79248cdf308a2ed7d54ef80.fbx";